module.exports = __webpack_public_path__ + "img/927.05121e7c.png";